// extracted by mini-css-extract-plugin
export default {"form_container":"styles_form_container__lomin","input":"styles_input__4BKvW","btn_submit":"styles_btn_submit__5AVoZ"};